// extracted by css-extract-rspack-plugin
export default {"cls1":"FreeformQuestion-cls1_ERh","cls2":"FreeformQuestion-cls2_Hzj FreeformQuestion-cls1_ERh"};